import { Component, OnInit, Output, Input, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-editable-field',
  templateUrl: './editable-field.component.html',
  styleUrls: ['./editable-field.component.scss']
})
export class EditableFieldComponent implements OnInit, OnChanges {

  @Input() modelValue: any ;
  @Input() type: any = 'text' ;
  @Input() placeHolder: any;
  @Output() onModelChanged = new EventEmitter();

  saved:boolean = false;
  modelObject: any = {};

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.modelObject.modelValue = this.modelValue;
  }

  /**
   * emit if model value is changed.
   * @param modelObject 
   */
  updateAttributeValue(modelObject) {
    if (modelObject.oldValue.toString()?.trim() !== modelObject.modelValue.toString()?.trim()) {
      this.onModelChanged.emit(modelObject.modelValue);
    }
    this.saved = true;
  }

  onTyping(){
    this.saved = false;
  }
  
}
